import { useEffect } from 'react';
import { ifDevMessage } from './devMessage';
export var deprecatedComponentMessage = function (_a) {
    var componentName = _a.componentName, date = _a.date, upgradeURL = _a.upgradeURL;
    ifDevMessage("[DEPRECATION] <" + componentName + " />\n" +
        ("Carina <" + componentName + " /> is deprecated and will be removed at the end of " + date + "! ") +
        'Check out the link below for upgrade guidance. \n' +
        upgradeURL);
};
export var deprecatedPropValueMessage = function (_a) {
    var componentName = _a.componentName, propName = _a.propName, propValue = _a.propValue, date = _a.date, upgradeURL = _a.upgradeURL;
    ifDevMessage("[PROP VALUE DEPRECATION]: <" + componentName + " " + propName + "='" + propValue + "' />\n" +
        ("Value '" + propValue + "' for property '" + propName + "' is deprecated and will be removed at the end of " + date + "! ") +
        'Check out the link below for upgrade guidance.\n' +
        upgradeURL);
};
export var useDeprecatedComponentMessage = function (messageOptions) {
    useEffect(function () {
        deprecatedComponentMessage(messageOptions);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); // only render once
};
